<div class="cleanup-administration">

    <div class="widget-menu-layer-1 no-field-space top-toolbar">

        <div class="top-toolbar-layout" [formGroup]="carrierQueryFormGroup">
            
            <mat-form-field class="query-field">
                <input matInput formControlName="query" name="query" [minlength]="1" required="true"
                    placeholder="{{'carrier query' | translate:['tmc-yard.widgets.cleanup-administration.carrier-query', translationService.language] }}">
            </mat-form-field>

            <div class="spaced"></div>

            <button mat-flat-button type="button" (click)="findCarriersByQuery()"
                [disabled]="loading || !carrierQueryValid">
                {{'find' | translate:['tmc-yard.widgets.cleanup-administration.action.find-carrier',
                translationService.language]}}
            </button>
        </div>

        <div class="help">{{'' | translate:['tmc-yard.widgets.cleanup-administration.help.find-carrier',
            translationService.language]}}</div>

    </div>

    <div class="response-container" *ngIf="responseMessages != null && responseMessages.length > 0">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <div class="table-container">

        <table mat-table [dataSource]="dataSource" class="table">

            <ng-container matColumnDef="checkbox">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell class="" *matCellDef="let carrier">
                    <mat-checkbox [(ngModel)]="carrier.selected" (ngModelChange)="carrierSelectionChanged()">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="carrier">
                <th mat-header-cell *matHeaderCellDef>
                    {{'carrier'| translate:['tmc-yard.entity.transport.carrier',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let carrier">
                    {{carrier.carrier}}
                </td>
            </ng-container>

            <ng-container matColumnDef="count">
                <th mat-header-cell *matHeaderCellDef>
                    {{'count'| translate:['tmc-yard.widgets.cleanup-administration.carrier.count',
                    translationService.language]}}
                </th>
                <td mat-cell class="" *matCellDef="let carrier">
                    {{carrier.count}}
                </td>
            </ng-container>

            <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
            <ng-container matColumnDef="noRecord">
                <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
                    {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

            <tr mat-row *matRowDef="let carrier; columns: columnsToDisplay">
            </tr>

            <tr [class.hide]="this.dataSource.filteredData.length !== 0" mat-footer-row *matFooterRowDef="['noRecord']">
            </tr>
        </table>
    </div>

    <div class="bottom-toolbar" [formGroup]="carrierReplacementFormGroup">
        <mat-form-field class="name-field">
            <input matInput formControlName="replacement" name="replacement" [minlength]="1" required="true"
                placeholder="{{'updated carrier' | translate:['tmc-yard.widgets.cleanup-administration.update-carrier-with', translationService.language] }}">
        </mat-form-field>

        <div class="spaced"></div>

        <button mat-flat-button type="button" (click)="findAndReplace()" [disabled]="loading || !replaceButtonEnabled">
            {{'replace' | translate:['tmc-yard.widgets.cleanup-administration.action.update-carrier',
            translationService.language]}}
        </button>
    </div>
</div>